import React, { Component } from 'react';
import Row from './Row'
import { iconEmpty } from './../../../../services/helper'

class Rows extends Component {
    renderRows = () => {
        if(!this.props.listDataValidate.length) {
            return (
                <tr>
                    <td colSpan={5}>{iconEmpty('No Error')}</td>
                </tr>
            )
        }
        return this.props.listDataValidate.map((e, i) => {
            return <Row     
                dataPreview={e}
                key={i}
                keyRow={i}
            />
        })
    }

    render() {
        return (
            <tbody>{this.renderRows()}</tbody>
        );
    }
}

export default Rows;


// WEBPACK FOOTER //
// ./src/components/step-import-order/components/import-validate/Rows.js